import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import Pagination from '../../helpers/Pagination';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getInbox} from '../../actions/inboxAction';

const $= window.$;

class Archieve extends Component {
	constructor(props) {
		super(props);
        this.state={
           archieve_mail : [],
           count : 0,
           pageOfItems:[],
           idd : '',
           searchtext:'',
           datas : [],
           checkedValues:[],
           msg_ids:[],
        };
        this.onChangePage = this.onChangePage.bind(this);
        this.viewItem = this.viewItem.bind(this);
        this.getCheck = this.getCheck.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getSearch = this.getSearch.bind(this);
        this.Replydata = this.Replydata.bind(this);
		this.onSort = this.onSort.bind(this);
		this.changeStatus=this.changeStatus.bind(this);
	}

    componentWillReceiveProps(nextProps) {
    	this.getArchieve();
	}

	viewItem(edit_id,msg_id){
		let learnerID = Common.getUserData("id", true);
		let old_id = this.state.idd;
		if(edit_id == old_id){
			// alert('same');
			if($("#"+edit_id).css('display')=='none'){
				$("#"+edit_id).show();
			}
			else{

				$("#"+edit_id).hide();
			}
		}
		else{
			$("#"+old_id).hide();
			$("#"+edit_id).show();
		}
		$("#msgidsent"+msg_id).removeAttr("class");
		fetch(Config.domainUrl+'messages-site/mark-as', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    tobe_markedas:[msg_id],learner_id:learnerID,selected:'read',
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               //	alert(JSON.stringisy(responseJson));
                 if (responseJson.status != 0) {
					//this.getArchieve();
			    }


   		 });
	   const msg_ids = [...this.state.msg_ids,{msg_id}];
       this.setState({
			idd : edit_id,
			msg_ids
		})
	}

	Replydata(msg_id,from,subject,content,alldata){
		this.props.Replydatas(msg_id,from,subject,content,alldata);
	}

	onSort(event, sortKey){
	 	// alert('im in');
	    const pageOfItems = this.state.pageOfItems;
	    pageOfItems.sort((a,b) => a[sortKey].localeCompare(b[sortKey]))
	    this.setState({pageOfItems})
	  }

	changeStatus(e){
		let selected = e.target.value;
		if(selected != ""){

			let values = this.state.checkedValues;
			if(values.length == 0){
				Common.message('','Please select the message(s) to mark as '+selected);
			}
			else{
				window.swal({
			      //title: 'Mark As!',
			      text: 'Are you sure, you want to '+selected+' the selected message(s)?',
			      //type: 'question',
			      showCancelButton: true,
				  confirmButtonColor: '#14a430',
				  cancelButtonColor: '#0082c9',
				  animation: false,
			      confirmButtonText: 'Ok'
			    }).then((result) => {
			      	if(result){
				    	let learnerID = Common.getUserData("id", true);
				    	fetch(Config.domainUrl+'messages-site/mark-as', {
				                method: 'POST',
				                headers: {
				                  'Accept': 'application/json',
				                  'Content-Type': 'application/json',
								  'Authorization':'Bearer ' +Common.getTokenData()
				                },

				                  body: JSON.stringify({
				                    tobe_markedas:values,learner_id:learnerID,selected:selected
				                  })
				                }).then((response) => response.json())
				               .then((responseJson) => {
				               //	alert(JSON.stringisy(responseJson));
				                 if (responseJson.status == 0) {
							       Common.message(responseJson.message,responseJson.errors,'error');
							    }else{
							      Common.message('Success',responseJson.message,'success');
							      $('.chkslctt_inbox').prop('checked',false);
							      this.getArchieve();
								  this.props.getInbox();
							    }


				   		 });

			      	}
			    });
			}
		}

		$('#archieve_cmbMark').val('');
		$('#checkAll_arch').removeAttr('checked');
	}

	getCheck(){
		var checkedValues = $('.chkslctt_inbox:checked').map(function() {
			return this.value;
		}).get();
		this.setState({
			checkedValues : checkedValues,
		})

	}

	selectAll(){
		if($('#checkAll_arch').is(':checked')){
	    	$('.chkslctt_inbox').prop('checked',true);
	    }
	    else{
	        $('.chkslctt_inbox').prop('checked',false);
	    }
	    var checkedValues = $('.chkslctt_inbox:checked').map(function() {
			return this.value;
		}).get();
		this.setState({
			checkedValues : checkedValues,
		})
	}
	_handleKeyPress(e) {
		if (e.key === "Enter") {
			this.getSearch('search');
		}
	}
	getSearch(){
    	let queryText = this.state.searchtext;
    	var queryResult=[];
        this.state.datas.forEach(function(person){
            if(person.from_address.toString().toLowerCase().indexOf(queryText)!=-1){

            	queryResult.push(person);
            }
        	else if(person.subject.toString().toLowerCase().indexOf(queryText)!=-1){

        		queryResult.push(person);
        	}
        	let total = queryResult.length;
	        this.setState({
	       		archieve_mail : queryResult,
	       		count : total,
	        })
        }.bind(this));
    }

	handleChange(e){
    	this.setState({
    		[e.target.name] : e.target.value
    	})
    }


	getArchieve(){
		let searchtext = '';
		let learnerID = Common.getUserData("id", true);
	 // 	let corporateID = Common.getUserData("corporateID", true);
		// let productID = Common.getUserData("productID", true);
		let admin_role = Common.getUserData("role", true);

    	fetch(Config.domainUrl+'messages-site/get-archieve', {
	        method: 'POST',
	        headers: {
	          'Accept': 'application/json',
	          'Content-Type': 'application/json',
			  'Authorization':'Bearer ' +Common.getTokenData()
	        },

	          body: JSON.stringify({
	            learner_id:learnerID,admin_role:admin_role
	          })
	        }).then((response) => response.json())
	       .then((responseJson) => {
	      	//alert(JSON.stringify(responseJson.archieve_mail));
	       	if(responseJson.status != 0){
	       		let total_message = responseJson.archieve_mail.length;
	            this.setState({
	            	datas : responseJson.archieve_mail,
	            	archieve_mail:responseJson.archieve_mail,
	            	count : total_message,
	            	pageOfItems:responseJson.archieve_mail,
	            	searchtext:searchtext,
	            });

	       	}

   		 });
	}


    componentDidMount() {
    	// alert('here');
  //   	$('table.search-table').tableSearch({
		// 	searchText:'Search',
		// 	searchPlaceHolder:'Search Here'
		// });
		setTimeout(() => {
    		this.getArchieve();
		}, 100);
    }

    onChangePage(pageOfItems) {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
        $('#'+this.state.idd).hide();
    }



		render() {

			//alert(JSON.stringify(this.state.checkedValues));
			let rows = this.state.pageOfItems.map((mail,i) => {
				let msg_id = mail.msg_user_id_pk;
				let class_in = "";
				if(mail.inbox == 2){
					class_in = "yellowbg yellowbg-txt";
				}
				else{
					class_in = "";
				}
				let value = i+1;
				this.state.msg_ids.map((ids)=>{
					// $('#msgid'+ids.msg_id).removeAttr('class');
					if(msg_id == ids.msg_id){
						class_in = '';
					}
				});
				let edit = 'view_edit_archieve'+msg_id;
				let attach = mail.attached_files.map((att,k)=>{

					let  file_sent = Config.domainUrl+att.fullpath;
					let new_file = new Buffer(file_sent).toString("base64");
					return(
							<div key={`att_${k}`} className="msg-cont"><a href={`${Config.domainUrl}download/admin/${new_file}`}>{att.filename}</a></div>
						)
				})
                return (
                		<tbody key={`mail_${i}`}>
		                   <tr  id={'msgidsent'+msg_id} className={class_in}>
		                   		<td><input type="checkbox" name={"chkInbox"+value} id={"chkInbox"+value} value={mail.msg_user_id_pk} className="chkslctt_inbox" onClick={(e)=>this.getCheck(e)} /></td>
			                   	<td><span dangerouslySetInnerHTML={{__html:mail.attachment}}/></td>
				                <td><a href='javascript:void(0);' onClick={(e)=>this.viewItem(edit,msg_id)}>{mail.from_address}</a></td>
				                <td><a href='javascript:void(0);' onClick={(e)=>this.viewItem(edit,msg_id)}>{mail.subject}</a></td>
				                <td>{mail.created_date+' IST'}</td>
		                   </tr>
		                   <tr id={'view_edit_archieve'+msg_id} style={{display:'none'}}>
		                   		<td colSpan="5" className="view-msg1">
									<div id={"view_send_item"+msg_id} >
										<div className="msg-deatil-cont " id="Detailview">
											<div className="msg-deatil-cont-head " id="viewline" >
						   						<ul>
						                        <li>
						                            <div className="msg-label">From</div>
						                            <div className="msg-cont">{mail.from_address}</div>
						                        </li>
						                        <li>
						                            <div className="msg-label">Date</div>
						                            <div className="msg-cont">{mail.created_date+' IST'}</div>
						                        </li>
						                        {(mail.cc_address=='')?"":
												<li>
													<div className="msg-label">Cc</div>
													<div className="msg-cont">{mail.cc_address}</div>
												</li>
												}
						                       <li>
													<div className="msg-label">Subject</div>
													<div className="msg-cont">{mail.subject}</div>
												</li>
												{(!mail.attached_files.length)?"":
												<li>
													<div className="msg-label">Attachment</div>
													{attach}
												</li>
												}
						                      </ul>
						       				  <div className="msg-detail-inner">
						       				  	<span dangerouslySetInnerHTML={{__html:mail.content}}/>
						       				  	{(mail.completed_status==0 && mail.role!="SYS")?<div className="button"><input type="button" title="Reply" value="Reply" onClick={()=>this.Replydata(mail.message_id_pk,mail.reply_email,mail.reply_subject,mail.reply_content,mail.allDatas)}/></div>:''}
						                      </div>
											</div>
						 					</div>
									</div>
								</td>
		                   </tr>
		                 </tbody>
		                )
		       });

			 (rows.length == 0) ? rows = <tbody><tr align="center"><td colSpan="5">No Archieve Mails.</td></tr></tbody> : rows = rows;

			return (
				<div >
					<h2>Messages - Archieve</h2>
						<div className="message-chart">
              				<div className="message-option">
              					<div className="check-box1">
				<select id="archieve_cmbMark" name="cmbMark" className="action_cmbbox" onChange={this.changeStatus}>
					<option value="">Actions</option>
					<option value="inbox">Move to Inbox</option>
				</select>
								</div>
                				<div className="searchmsg">
									<input type="text" name="searchtext" value={this.state.searchtext} onChange={(e)=>this.handleChange(e)} onKeyPress={(e)=>this._handleKeyPress(e)}/>&nbsp;&nbsp;
									<input type="button" name="submit" value="Search" title="Search" onClick={()=>this.getSearch('search')}/>&nbsp;&nbsp;
									<a href="javascript:void(0);" onClick={()=>this.getArchieve()} className="button-cancel">Reset</a>
                				</div>
								<div className="check-box2">
				                	<span>{"Total "+this.state.count+" messages"}</span>
						        </div>
							</div>
							<div className="tab-content table-cont6" style={{width:"100%"}}>
								<table width="100%" cellSpacing="0" cellPadding="0" border="0" className="myjourney-table message-table search-table">
									<thead>
										<tr>
											<th><input type="checkbox" id="checkAll_arch" onClick={(e)=>this.selectAll(e)} /></th>
											<th style={{width:'20px'}}><img title="Attachment" src={process.env.PUBLIC_URL+"/images/attachment-white.png"}/></th>
											<th onClick={(e)=>this.onSort(e, 'from_address')}><a className="mailsort" href="javascript:void(0);">From &nbsp;<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} border="0" align="absmiddle" /></a></th>
											<th>Subject</th>
											<th onClick={(e)=>this.onSort(e, 'created_date')}><a className="mailsort" href="javascript:void(0);">Received on &nbsp;<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} border="0" align="absmiddle" /></a></th>
										</tr>
									</thead>
									{rows}
								</table>
								<div className="pull-right">
								<Pagination items={this.state.archieve_mail} onChangePage={e=>this.onChangePage(e)} />
								</div>
							</div>
						</div>
				</div>
			);
		}
}


function mapDispatchToProps(dispatch) {

  return  bindActionCreators({getInbox}, dispatch);

}

export default connect(null,mapDispatchToProps)(Archieve);



// WEBPACK FOOTER //
// ./src/personal_interactions/messages/Archieve.js